import { render, staticRenderFns } from "./BookAppointmentCard.vue?vue&type=template&id=8a7226c2&scoped=true&"
import script from "./BookAppointmentCard.vue?vue&type=script&lang=js&"
export * from "./BookAppointmentCard.vue?vue&type=script&lang=js&"
import style0 from "./BookAppointmentCard.vue?vue&type=style&index=0&id=8a7226c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7226c2",
  null
  
)

export default component.exports